import { api } from '@/services'

export const list = (params) => {
  return api.get('/admin/vendor/list', { params })
}

export const show = (vendorId) => {
  return api.get(`/admin/vendor/show/${vendorId}`)
}

export const create = (vendor) => {
  return api.post('/admin/vendor/create', vendor)
}

export const update = (vendor) => {
  return api.put(`/admin/vendor/update/${vendor?.id}`, vendor)
}

export const remove = (vendorId) => {
  return api.delete(`/admin/vendor/delete/${vendorId}`)
}

export const findAll = () => {
  return api.get('/admin/vendor/findAll')
}
